// UC San Diego's undergraduate majors (#2596, founder 2026-09-30: "majors
// offered by the college in the public page"). Read on 2026-09-30. The General
// Catalog's degrees index (catalog.ucsd.edu/undergraduate/degrees-offered/) was
// read first but is stale: it misses majors the catalog's own department pages
// describe (Artificial Intelligence, Political Science/Data Analytics, ...). So
// the list is UC San Diego's official Undergraduate Majors page on TritonLink
// (students.ucsd.edu, updated 2026-09-23), which leaves specializations to the
// catalog. Neither page groups by school, so it is one group. Degrees as the page
// writes them; paused and consecutive-only majors carry the page's own note.
// Flags quote the selective-majors list on the first-year requirements page (the
// college file's `requirements` source), for majors TritonLink stars under
// Engineering, Data Science or Public Health. The KB was the starting point.
const majors = {
    "slug": "university-of-california-san-diego",
    "read": "2026-09-30",
    "intro": "Every undergraduate major on UC San Diego's official list of undergraduate majors, with the degree it leads to. Specializations within a major, minors and graduate programs are left out.",
    "groups": [
        {
            "name": "Undergraduate Majors at UC San Diego",
            "source": {
                "label": "UC San Diego TritonLink, Undergraduate Majors at UC San Diego",
                "url": "https://students.ucsd.edu/academics/advising/majors-minors/undergraduate-majors.html"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "B.S.",
                    "flag": "A selective major, with limited enrollment due to capacity; UC San Diego strongly recommends listing an alternate major that is not selective.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Aerospace Engineering with a Specialization in Aerothermodynamics",
                    "degree": "B.S.",
                    "flag": "A selective major, with limited enrollment due to capacity; UC San Diego strongly recommends listing an alternate major that is not selective.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Aerospace Engineering with a Specialization in Astrodynamics and Space Applications",
                    "degree": "B.S.",
                    "flag": "A selective major, with limited enrollment due to capacity; UC San Diego strongly recommends listing an alternate major that is not selective.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Aerospace Engineering with a Specialization in Flight Dynamics and Controls",
                    "degree": "B.S.",
                    "flag": "A selective major, with limited enrollment due to capacity; UC San Diego strongly recommends listing an alternate major that is not selective.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Anthropology (Archaeology)",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology (Biological Anthropology)",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology (Sociocultural Anthropology)",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology with a Concentration in Climate Change and Human Solutions",
                    "degree": "B.A."
                },
                {
                    "name": "Art History/ Criticism",
                    "degree": "B.A."
                },
                {
                    "name": "Artificial Intelligence",
                    "degree": "B.S."
                },
                {
                    "name": "Astronomy & Astrophysics",
                    "degree": "B.S."
                },
                {
                    "name": "Astrophysical Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Biochemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Bioengineering",
                    "degree": "B.S.",
                    "flag": "A selective major, with limited enrollment due to capacity; UC San Diego strongly recommends listing an alternate major that is not selective.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Bioengineering (Bioinformatics)",
                    "degree": "B.S.",
                    "flag": "A selective major, with limited enrollment due to capacity; UC San Diego strongly recommends listing an alternate major that is not selective.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Bioengineering (Biotechnology)",
                    "degree": "B.S.",
                    "flag": "A selective major, with limited enrollment due to capacity; UC San Diego strongly recommends listing an alternate major that is not selective.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Bioengineering: BioSystems",
                    "degree": "B.S.",
                    "flag": "A selective major, with limited enrollment due to capacity; UC San Diego strongly recommends listing an alternate major that is not selective.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Biological Anthropology",
                    "degree": "B.S."
                },
                {
                    "name": "Biology with Specialization in Bioinformatics",
                    "degree": "B.S."
                },
                {
                    "name": "Black Diaspora and African American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Business Data Science",
                    "degree": "B.S.",
                    "flag": "A selective major, with limited enrollment due to capacity; UC San Diego strongly recommends listing an alternate major that is not selective.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Business Economics",
                    "degree": "B.S."
                },
                {
                    "name": "Business Psychology",
                    "degree": "B.S."
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "B.S.",
                    "flag": "A selective major, with limited enrollment due to capacity; UC San Diego strongly recommends listing an alternate major that is not selective.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Chicanx and Latinx Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Chinese Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Cinematic Arts",
                    "degree": "B.A."
                },
                {
                    "name": "Classical Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Cognitive and Behavioral Neuroscience",
                    "degree": "B.S."
                },
                {
                    "name": "Cognitive Science",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Cognitive Science with Specialization in Clinical Aspects of Cognition",
                    "degree": "B.S."
                },
                {
                    "name": "Cognitive Science with Specialization in Design and Interaction",
                    "degree": "B.S."
                },
                {
                    "name": "Cognitive Science with Specialization in Language and Culture",
                    "degree": "B.S."
                },
                {
                    "name": "Cognitive Science with Specialization in Machine Learning and Neural Computation",
                    "degree": "B.S."
                },
                {
                    "name": "Cognitive Science with Specialization in Neuroscience",
                    "degree": "B.S."
                },
                {
                    "name": "Communication",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Engineering",
                    "degree": "B.S.",
                    "flag": "A selective major, with limited enrollment due to capacity; UC San Diego strongly recommends listing an alternate major that is not selective.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S.",
                    "flag": "A selective major, with limited enrollment due to capacity; UC San Diego strongly recommends listing an alternate major that is not selective.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Computer Science with Specialization in Bioinformatics",
                    "degree": "B.S.",
                    "flag": "A selective major, with limited enrollment due to capacity; UC San Diego strongly recommends listing an alternate major that is not selective.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Critical Gender Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Dance",
                    "degree": "B.A."
                },
                {
                    "name": "Data Science",
                    "degree": "B.S.",
                    "flag": "A selective major, with limited enrollment due to capacity; UC San Diego strongly recommends listing an alternate major that is not selective.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Ecology, Behavior and Evolution",
                    "degree": "B.S."
                },
                {
                    "name": "Economics",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Economics and Mathematics - Joint Major",
                    "degree": "B.S."
                },
                {
                    "name": "Economics-Public Policy",
                    "degree": "B.A./MPP",
                    "note": "Entry is restricted to students accepted into the consecutive degree program."
                },
                {
                    "name": "Economics-Public Policy",
                    "degree": "B.S./MPP",
                    "note": "Entry is restricted to students accepted into the consecutive degree program."
                },
                {
                    "name": "Education Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S.",
                    "flag": "A selective major, with limited enrollment due to capacity; UC San Diego strongly recommends listing an alternate major that is not selective.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Electrical Engineering and Society",
                    "degree": "B.A.",
                    "flag": "A selective major, with limited enrollment due to capacity; UC San Diego strongly recommends listing an alternate major that is not selective.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Engineering Physics",
                    "degree": "B.S.",
                    "flag": "A selective major, with limited enrollment due to capacity; UC San Diego strongly recommends listing an alternate major that is not selective.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Environmental Anthropology",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Systems (Earth Sciences)",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Systems (Ecology, Behavior, & Evolution)",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Systems (Environmental Chemistry)",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Systems (Environmental Policy)",
                    "degree": "B.A."
                },
                {
                    "name": "Ethnic Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Experimental Psychology",
                    "degree": "B.S."
                },
                {
                    "name": "General Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Geosciences",
                    "degree": "B.S."
                },
                {
                    "name": "German Studies",
                    "degree": "B.A.",
                    "note": "Entry into this major is paused through Spring 2028."
                },
                {
                    "name": "Global Health",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Global South Studies",
                    "degree": "B.A.",
                    "note": "Entry into this major is paused through Spring 2029."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Human Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Human Developmental Sciences",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Human Developmental Sciences with a Specialization in Equity and Diversity",
                    "degree": "B.S."
                },
                {
                    "name": "Human Developmental Sciences with a Specialization in Healthy Aging",
                    "degree": "B.S."
                },
                {
                    "name": "Individual Majors",
                    "degree": null,
                    "note": "Each college offers an individual major for a B.A. degree; Revelle College offers a B.A. and B.S."
                },
                {
                    "name": "Interdisciplinary Computing and the Arts",
                    "degree": "B.A."
                },
                {
                    "name": "International Studies - Anthropology",
                    "degree": null
                },
                {
                    "name": "International Studies - Economics",
                    "degree": null
                },
                {
                    "name": "International Studies - Economics",
                    "degree": "B.A./MIA"
                },
                {
                    "name": "International Studies - History",
                    "degree": null
                },
                {
                    "name": "International Studies - International Business",
                    "degree": null
                },
                {
                    "name": "International Studies - International Business",
                    "degree": "B.A./MIA"
                },
                {
                    "name": "International Studies - Linguistics",
                    "degree": null
                },
                {
                    "name": "International Studies - Literature",
                    "degree": null
                },
                {
                    "name": "International Studies - Philosophy",
                    "degree": null
                },
                {
                    "name": "International Studies - Political Science",
                    "degree": null
                },
                {
                    "name": "International Studies - Political Science",
                    "degree": "B.A./MIA"
                },
                {
                    "name": "International Studies - Sociology",
                    "degree": null
                },
                {
                    "name": "Italian Studies",
                    "degree": "B.A.",
                    "note": "Entry into this major is paused through Spring 2028."
                },
                {
                    "name": "Japanese Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Jewish Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Latin American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Latin American Studies with a Concentration in Mexico",
                    "degree": "B.A."
                },
                {
                    "name": "Latin American Studies with a Concentration in Migration and Border Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics (Specialization in Cognition and Language)",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics (Specialization in Language and Society)",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics (Specialization in Speech and Language Sciences)",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics: Language Studies (Specialization in Individual Language)",
                    "degree": "B.A."
                },
                {
                    "name": "Literary Arts",
                    "degree": "B.A."
                },
                {
                    "name": "Literatures in English",
                    "degree": "B.A."
                },
                {
                    "name": "Marine Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematical Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics (Applied)",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics - Applied Science",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics - Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics - Secondary Education",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics and Economics - Joint Major",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S.",
                    "flag": "A selective major, with limited enrollment due to capacity; UC San Diego strongly recommends listing an alternate major that is not selective.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Mechanical Engineering with a Specialization in Controls and Robotics",
                    "degree": "B.S.",
                    "flag": "A selective major, with limited enrollment due to capacity; UC San Diego strongly recommends listing an alternate major that is not selective.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Mechanical Engineering with a Specialization in Fluid Mechanics and Thermal Systems",
                    "degree": "B.S.",
                    "flag": "A selective major, with limited enrollment due to capacity; UC San Diego strongly recommends listing an alternate major that is not selective.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Mechanical Engineering with a Specialization in Materials Science and Engineering",
                    "degree": "B.S.",
                    "flag": "A selective major, with limited enrollment due to capacity; UC San Diego strongly recommends listing an alternate major that is not selective.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Mechanical Engineering with a Specialization in Mechanics of Materials",
                    "degree": "B.S.",
                    "flag": "A selective major, with limited enrollment due to capacity; UC San Diego strongly recommends listing an alternate major that is not selective.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Mechanical Engineering with a Specialization in Renewable Energy and Environmental Flows",
                    "degree": "B.S.",
                    "flag": "A selective major, with limited enrollment due to capacity; UC San Diego strongly recommends listing an alternate major that is not selective.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Media",
                    "degree": "B.A."
                },
                {
                    "name": "Media Industries and Communication",
                    "degree": "B.A."
                },
                {
                    "name": "Microbiology",
                    "degree": "B.S."
                },
                {
                    "name": "Molecular and Cell Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Molecular Synthesis",
                    "degree": "B.S."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Music Humanities",
                    "degree": "B.A."
                },
                {
                    "name": "NanoEngineering",
                    "degree": "B.S.",
                    "flag": "A selective major, with limited enrollment due to capacity, and a screened major at UC San Diego; list an alternate major that is not selective.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Neurobiology",
                    "degree": "B.S."
                },
                {
                    "name": "Oceanic and Atmospheric Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Oceanic and Atmospheric Sciences",
                    "degree": "B.S./MPP",
                    "note": "Entry is restricted to students accepted into the consecutive degree program."
                },
                {
                    "name": "Pharmacological Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science/American Politics",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science/Comparative Politics",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science/Data Analytics",
                    "degree": "B.S."
                },
                {
                    "name": "Political Science/International Affairs",
                    "degree": "B.A./MIA",
                    "note": "Entry is restricted to students accepted into the consecutive degree program."
                },
                {
                    "name": "Political Science/International Relations",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science/Political Theory",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science/Public Law",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science/Public Policy",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science/Race, Ethnicity, and Politics",
                    "degree": "B.A."
                },
                {
                    "name": "Probability and Statistics",
                    "degree": "B.S."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology with a Specialization in Clinical Psychology",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Public Health",
                    "degree": "B.S.",
                    "flag": "A selective major, with limited enrollment due to capacity; UC San Diego strongly recommends listing an alternate major that is not selective.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Public Health with Concentration in Biostatistics",
                    "degree": "B.S.",
                    "flag": "A selective major, with limited enrollment due to capacity; UC San Diego strongly recommends listing an alternate major that is not selective.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Public Health with Concentration in Climate and Environmental Sciences",
                    "degree": "B.S.",
                    "flag": "A selective major, with limited enrollment due to capacity; UC San Diego strongly recommends listing an alternate major that is not selective.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Public Health with Concentration in Community Health Sciences",
                    "degree": "B.S.",
                    "flag": "A selective major, with limited enrollment due to capacity; UC San Diego strongly recommends listing an alternate major that is not selective.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Public Health with Concentration in Epidemiology",
                    "degree": "B.S.",
                    "flag": "A selective major, with limited enrollment due to capacity; UC San Diego strongly recommends listing an alternate major that is not selective.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Public Health with Concentration in Health Policy and Management Sciences",
                    "degree": "B.S.",
                    "flag": "A selective major, with limited enrollment due to capacity; UC San Diego strongly recommends listing an alternate major that is not selective.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Public Health with Concentration in Medicine Sciences",
                    "degree": "B.S.",
                    "flag": "A selective major, with limited enrollment due to capacity; UC San Diego strongly recommends listing an alternate major that is not selective.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Real Estate and Development",
                    "degree": "B.S."
                },
                {
                    "name": "Russian, East European & Eurasian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology - American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology - Culture and Communication",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology - Economy and Society",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology - International Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology - Law and Society",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology - Science and Medicine",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology - Social Inequality",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish Literature",
                    "degree": "B.A."
                },
                {
                    "name": "Speculative Design",
                    "degree": "B.A."
                },
                {
                    "name": "Structural Engineering",
                    "degree": "B.S.",
                    "flag": "A selective major, with limited enrollment due to capacity, and a screened major at UC San Diego; list an alternate major that is not selective.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Structural Engineering with a Specialization in Aerospace Structures",
                    "degree": "B.S.",
                    "flag": "A selective major, with limited enrollment due to capacity, and a screened major at UC San Diego; list an alternate major that is not selective.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Structural Engineering with a Specialization in Civil Structures",
                    "degree": "B.S.",
                    "flag": "A selective major, with limited enrollment due to capacity, and a screened major at UC San Diego; list an alternate major that is not selective.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Structural Engineering with a Specialization in Geotechnical Engineering",
                    "degree": "B.S.",
                    "flag": "A selective major, with limited enrollment due to capacity, and a screened major at UC San Diego; list an alternate major that is not selective.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Structural Engineering with a Specialization in Structural Health Monitoring/Non-Destructive Evaluation",
                    "degree": "B.S.",
                    "flag": "A selective major, with limited enrollment due to capacity, and a screened major at UC San Diego; list an alternate major that is not selective.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Studio",
                    "degree": "B.A."
                },
                {
                    "name": "Study of Religion",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre",
                    "degree": "B.A."
                },
                {
                    "name": "Urban Studies and Planning",
                    "degree": "B.A."
                },
                {
                    "name": "World Literature and Culture",
                    "degree": "B.A."
                }
            ]
        }
    ]
};

export default majors;
